import React from "react";
import { useTranslation } from "react-i18next";

const PaymentsTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="card-body">
      <p className="text-muted mb-0">
        {t('reconciliation.managerStatement.detail.pageTexts.paymentsTab.emptyState')}
      </p>
    </div>
  );
};

export default PaymentsTab;
